import { render, staticRenderFns } from "./MovimentacoesProcesso.vue?vue&type=template&id=1ad8199f&"
import script from "./MovimentacoesProcesso.vue?vue&type=script&lang=js&"
export * from "./MovimentacoesProcesso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports